import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import { logUI } from '../../api/andyliticsApi';
import DataGrid from '../../../../OurModules/DataGrid/src/index.js';
import moment from 'moment-timezone';

class InvoiceDetails extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            invoiceId: props.location.state.invoiceId,
            showLoader: true,
            shouldLoadData: true,
            showEnrollmentAdjGrid: false,
            showFinancialAdjGrid: false,
            invoiceDetails:null
        };
        this.getCamelCasing = this.getCamelCasing.bind(this);
        this.printInvoiceDetails = this.printInvoiceDetails.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.InvoiceDetails.ComponentDidMount", new Date(), Tools.getURLPath());
        this.componentDidUpdate(this.props);
    }

    componentDidUpdate(prevProps) {
        if (this.props.invoiceDetails !== prevProps.invoiceDetails || this.props.invoiceAdjustments !== prevProps.invoiceAdjustments) {
            if (this.props.invoiceDetails && this.props.invoiceAdjustments) {

                let invoicedetails = this.props.invoiceDetails;
                invoicedetails = this.getCamelCasing(invoicedetails);
                invoicedetails.invoiceHeader = this.getCamelCasing(invoicedetails.invoiceHeader);
                invoicedetails.premiumDetails = this.getCamelCasing(invoicedetails.premiumDetails);
                this.state.invoiceDetails = invoicedetails;

                if (this.props.invoiceAdjustments.retroAdjustments) {
                    this.props.invoiceAdjustments.retroAdjustments.length > 0
                        ? this.setState({ showEnrollmentAdjGrid: true })
                        : this.setState({ showEnrollmentAdjGrid: false })
                }
                if (this.props.invoiceAdjustments.manualAdjustments) {
                    this.props.invoiceAdjustments.manualAdjustments.length > 0
                        ? this.setState({ showFinancialAdjGrid: true })
                        : this.setState({ showFinancialAdjGrid: false })
                }
                //since coverageEffective date is coming back as empty (due no matching field from HR)
                //we need to handle it this way for now, till we have a permanent solution
                if (this.state.invoiceDetails.premiumDetails) {
                    this.state.invoiceDetails.premiumDetails.map((x) => {
                        if (x.coverageEffective) {
                            return x.coverageEffective = moment(x.coverageEffective).format("MM/DD/YYYY");
                        }
                    });
                }

                this.setState({ showLoader: false });
            }
        }

        if ((this.props.hpIdentity || this.props.swhp) && this.state.shouldLoadData && !this.props.isFetching) {
            this.props.getInvoiceDetails(this.state.invoiceId);
            this.props.getInvoiceAdjustments(this.state.invoiceId);
            this.setState({ shouldLoadData: false });
        }
    }

    getCamelCasing(object) {
        var newO, origKey, newKey, value;
        newO = {}
        if (object instanceof Array) {
            object = object.map((s) => {
                var newO, origKey, newKey, value;
                newO = {};

                for (origKey in s) {
                    if (s.hasOwnProperty(origKey)) {
                        newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                        value = s[origKey];
                        newO[newKey] = value;
                    }
                }
                s = newO;
                return s;
            });
        }
        else {
            for (origKey in object) {
                if (object.hasOwnProperty(origKey)) {
                    newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                    value = object[origKey];
                    newO[newKey] = value;
                }
            }
            object = newO;
        }
        return object;
    }

    goBack() {
        this.props.history.goBack();
    }

    printInvoiceDetails() {
        var menu = document.getElementsByClassName('menu')[0];
        var menuListItems = menu.getElementsByClassName('menu-list')[0];

        //inject class to hide side bar class
        menuListItems.classList.add("hide-side-bar");

        window.print();

        //once print window closes, remove hide side class
        menuListItems.classList.remove("hide-side-bar");
    }

    render() {
        var formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        var columnPremiumsMetadata = [
            {
                type: "string",
                title: "Employee#",
                value: "employeeNumber",
                allowSorting: true
            },
            {
                type: "string",
                title: "Employee Name",
                value: "employeeName",
                allowSorting: true
            },
            {
                type: "string",
                title: "Coverage Effective",
                value: "coverageEffective",
                allowSorting: true
            },
            {
                type: "date",
                title: "Bill Period",
                value: "billPeriod",
                dateFormat: "MMM YYYY",
                allowSorting: true
            },
            {
                type: "string",
                title: "Tier",
                value: "tier",
                allowSorting: true
            },
            {
                type: "string",
                title: "Benefit Plan",
                value: "benefitPlan",
                allowSorting: true
            },
            {
                type: "string",
                title: "Family Size",
                value: "familySize",
                allowSorting: true
            },
            {
                type: "string",
                title: "Amount",
                value: "premiumAmount",
                allowSorting: true
            }
        ]
        var gridPremiumsMetadata = {
            title: "Premiums",
            selectable: false,
            enableFilters: true,
            filters: [{ filterName: "Employee", dataKeyToUse: "employeeName" }, { filterName: "Benefit Plan", dataKeyToUse: "benefitPlan" }, { filterName: "Tier", dataKeyToUse: "tier" }],
            searchFields: ["employeeName", "employeeNumber", "benefitPlan"],
            searchPlaceholder: "Search by employee name, number or benefit plan",
            dateField: "billPeriod",
            enableExport: true,
            enableSearch: true,
            enableDateRange: true, //not implemented
            exportFormats: ["xls"],
            exportName: "Premiums",
            sortingEnabled: true,
            pagination: false, //not implemented
            rowsPerPage: 10, //not implemented
            columns: columnPremiumsMetadata
        }

        var columnMetadataFinancialAdjustments = [
            {
                type: "string",
                title: "Benefit Plan",
                value: "benefitPlan",
                allowSorting: false
            },
            {
                type: "date",
                title: "Adjustment Date",
                value: "adjustmentDate",
                dateFormat: "MM/DD/YYYY",
                allowSorting: false
            },
            {
                type: "string",
                title: "Description",
                value: "description",
                allowSorting: false
            },
            {
                type: "string",
                title: "Adjustment Amount",
                value: "adjustmentAmount",
                allowSorting: false
            }
        ]
        var gridMetadataFinancialAdjustments = {
            title: "",
            selectable: false,
            enableFilters: false,
            filters: [],
            searchFields: [],
            searchPlaceholder: "",
            enableExport: true,
            enableSearch: false,
            enableDateRange: false, //not implemented
            exportFormats: ["xls"],
            exportName: "Financial Adjustments",
            sortingEnabled: false,
            pagination: false, //not implemented
            rowsPerPage: 0, //not implemented
            columns: columnMetadataFinancialAdjustments
        }

        var columnMetadataEnrollmentAdjustments = [
            {
                type: "string",
                title: "Employee Name",
                value: "memberName",
                allowSorting: false
            },
            {
                type: "date",
                title: "Coverage Effective",
                value: "effectiveDate",
                dateFormat: "MM/DD/YYYY",
                allowSorting: false
            },
            {
                type: "date",
                title: "Bill Period",
                value: "billPeriodDate",
                dateFormat: "MMM YYYY",
                allowSorting: false
            },
            {
                type: "string",
                title: "Tier",
                value: "tier",
                allowSorting: false
            },
            {
                type: "string",
                title: "Benefit Plan",
                value: "benefitPlan",
                allowSorting: false
            },
            {
                type: "string",
                title: "Family Size",
                value: "familySize",
                allowSorting: false
            },
            {
                type: "string",
                title: "Adjustment Amount",
                value: "adjustmentAmount",
                allowSorting: false
            },
            {
                type: "string",
                title: "Employee Number",
                value: "memberId",
                allowSorting: false
            }
        ]
        var gridMetadataEnrollmentAdjustments = {
            title: "",
            selectable: false,
            enableFilters: false,
            filters: [],
            searchFields: [],
            searchPlaceholder: "",
            enableExport: true,
            enableSearch: false,
            enableDateRange: false, //not implemented
            exportFormats: ["xls"],
            exportName: "Enrollment Adjustments",
            sortingEnabled: false,
            pagination: false, //not implemented
            rowsPerPage: 0, //not implemented
            columns: columnMetadataEnrollmentAdjustments
        }

        return (
            <div className="container-fluid body-content hp">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="claim-wrapper">
                            {
                                this.state.showLoader
                                    ?
                                    <div id="invoice-details-spinner" className="spinner">
                                        <div className="bounce1" />
                                        <div className="bounce2" />
                                        <div className="bounce3" />
                                    </div>
                                    :
                                    <div className="invoice-container">
                                        <div className="row">
                                            <span className="link-text cursor-pointer" onClick={() => this.goBack()}>{'< Back'}</span>
                                        </div>

                                        <div className="hp-title">
                                            Invoice Details
                                        </div>

                                        <hr></hr>

                                        <div className="row claim-base-detail">
                                            <div className="col-12 col-sm-6">
                                                <span id="invoice-details-member-name" className="bold-text claim-base-label">Member:</span> {this.state.invoiceDetails.premiumDetails ? this.state.invoiceDetails.premiumDetails[0].employeeName : ""}
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="semi-bold-text control-item" onClick={() => this.printInvoiceDetails()}>
                                                    <span id="invoice-detail-print" className="link-text cursor-pointer"><span className="icon-print control-icon"></span><span> Print</span></span>
                                                </div>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <span id="invoice-details-billing-date" className="bold-text claim-base-label">Billing Date:</span> {this.state.invoiceDetails.invoiceHeader.billingDate ? moment(this.state.invoiceDetails.invoiceHeader.billingDate).format("MM/DD/YYYY") : ""}
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <span id="invoice-details-invoice-number" className="bold-text claim-base-label">Number:</span>{this.state.invoiceDetails.invoiceHeader.invoiceNumber}
                                            </div>
                                        </div>

                                        <hr></hr>

                                        <div className="row claim-status-detail">
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Payment Due</div>
                                                    <div id="invoice-details-payment-due-date" className="status-detail-label">{moment(this.state.invoiceDetails.invoiceHeader.paymentDueDate).format("MM/DD/YYYY")} </div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Billing Period</div>
                                                    <div id="invoice-details-billing-period" className="status-detail-label">{moment(this.state.invoiceDetails.invoiceHeader.paymentDueDate).format("MMM YYYY")}</div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Subscription ID</div>
                                                    <div id="invoice-details-subscription-id" className="status-detail-label">{this.state.invoiceDetails.invoiceHeader.subscriptionId}</div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Subaccount ID</div>
                                                    <div id="invoice-details-sub-account-id" className="status-detail-label">{this.state.invoiceDetails.invoiceHeader.subAccountId}</div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Bill To</div>
                                                    <div id="invoice-details-bill-to" className="status-detail-label">Individual</div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                            <div className="col-12 col-sm-6">
                                                <div className="status-column">
                                                    <div className="bold-text claim-label">Payment by EFT</div>
                                                    <div id="invoice-details-payment-by-eft" className="status-detail-label">{this.state.invoiceDetails.invoiceHeader.paymentByEft === "N" ? "NO" : "YES"}</div>
                                                </div>
                                                <hr></hr>
                                            </div>
                                        </div>


                                        <div className="alt-background">
                                            <div className="procedures-container">
                                                <div className="card">
                                                    <div className="card-header bold-text">
                                                        Account Summary
                                                    </div>
                                                    <div className="card-body">
                                                        <div className="row card-top">
                                                            <div className="col-12 col-sm-6">
                                                                <div className="status-column">
                                                                    <div className="bold-text claim-label">Previous Invoice Amount</div>
                                                                    <div id="invoice-details-previous-invoice-amount" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.previousInvoiceAmount)}</div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>
                                                            <div className="col-12 col-sm-6">
                                                                <div className="status-column">
                                                                    <div className="bold-text claim-label">Payment Since Last Invoice</div>
                                                                    <div id="invoice-details-payment-since-last" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.paymentSinceLast)}</div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="status-column">
                                                                    <div className="bold-text claim-label">Balance Forward</div>
                                                                    <div id="invoice-details-balance-forward" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.balanceForward)}</div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="status-column">
                                                                    <div className="bold-text">Adjustments Since Last Invoice</div>
                                                                    <div id="invoice-details-adjustment-since-last" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.adjustmentSinceLast)}</div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>
                                                            <div className="col-12">
                                                                <div className="status-column">
                                                                    <div className="bold-text claim-label">Current Premiums</div>
                                                                    <div id="invoice-details-current-premium" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.currentPremium)}</div>
                                                                </div>
                                                                <hr></hr>
                                                            </div>

                                                            <div className="col-12 bold-text no-gutters highlighted-row amount-owed-wrapper">
                                                                <div className="status-column">
                                                                    <div className="bold-text">Total Amout Due</div>
                                                                    <div id="invoice-details-total-amount-due" className="status-detail-label">{formatter.format(this.state.invoiceDetails.invoiceHeader.totalAmountDue)}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <DataGrid id="invoice-details-premium-data-grid" dataSource={this.state.invoiceDetails.premiumDetails} gridOptions={gridPremiumsMetadata} showLoader={this.state.showLoader} />

                                        <br />

                                        <div className="hp-title">
                                            Adjustments
                                        </div>

                                        {!this.state.showFinancialAdjGrid && !this.state.showEnrollmentAdjGrid &&
                                            <div id="invoice-details-no-invoice-message">
                                                <div className="alt-background">
                                                    <div className="row">
                                                        <div className="col-12 col-sm-6">
                                                            <span>There are no adjustments to this invoice</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {this.state.showFinancialAdjExport &&
                                            <div>
                                                <div className="hp-title sub-header-indentation">
                                                    Financial Adjustments
                                                </div>
                                                <DataGrid id="invoice-details-manual-adjustments-data-grid" dataSource={this.props.invoiceAdjustments.manualAdjustments} gridOptions={gridMetadataFinancialAdjustments} showLoader={this.state.showLoader} />
                                            </div>
                                        }

                                        {this.state.showEnrollmentAdjGrid &&
                                            <div>
                                                <div className="hp-title sub-header-indentation">
                                                    Enrollment Adjustments
                                                </div>
                                                <DataGrid id="invoice-details-retro-adjustments-data-grid" dataSource={this.props.invoiceAdjustments.retroAdjustments} gridOptions={gridMetadataEnrollmentAdjustments} showLoader={this.state.showLoader} />
                                            </div>
                                        }
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        invoiceDetails: state.healthPlanServices.invoiceDetails,
        invoiceAdjustments: state.healthPlanServices.invoiceAdjustments,
        hpIdentity: state.session.healthPlanUserProfile,
        swhp: state.domain.hi,
        isFetching: state.healthPlanServices.isFetching,
        ...ownProps
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoiceDetails: (invoiceId) => dispatch({ type: types.HP_GET_INVOICE_DETAIL_START, invoiceId: invoiceId }),
        getInvoiceAdjustments: (invoiceId) => dispatch({ type: types.HP_GET_INVOICE_ADJUSTMENTS_START, invoiceId: invoiceId })
    };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InvoiceDetails))